import { BookmarkIcon, PrinterIcon } from '@heroicons/react/24/outline';
import EmptyState from '../../../components/empty-state';
import { FilterTabs } from '../../../components/filter-tabs'
import Download from '../../../components/icons/download';
import { AdminManageClerkCharts } from './components/admin-manage-clerk-charts';
import { AdminManageClerkHeader } from './components/admin-manage-clerk-header'
import useAdminManageClerk from './hooks/use-admin-manage-clerk';
import ClerkChartsList from "../clerk-charts/components/clerk-charts-list";

export default function AdminManageClerks() {
	const {
		clerk,
		tabs,
		selectedColor,
		setSelectedTab,
		selectedTab,
		readyToPrintCharts,
		otherChartTab,
		otherChartStatus,
		updateStatus,
		printedCharts,
		downloadAll,
		printAll,
		duplicateChart,
		downloadChart,
		markChartsAsPrinted,
		otherChartQuery,
		setOtherChartQuery,
	} = useAdminManageClerk();

	return (
		<div className="flex flex-col flex-grow w-full">
			<AdminManageClerkHeader clerk={clerk} />
			<div className='px-10'>
				<FilterTabs filterTabs={tabs} selectedTab={selectedTab} selectedColor={selectedColor} setSelectedTab={setSelectedTab} />
			</div>
			{selectedTab === 0 && readyToPrintCharts.length > 0 && (
				<div className='flex flex-col w-full pt-8'>
					<div className='flex flex-row justify-end w-full px-20 pb-10 -mt-10'>
						<div className='flex flex-row justify-end'>
							<button
								className="flex flex-row items-center text-base font-semibold cursor-pointer text-primary-blue"
								onClick={() =>
									downloadAll(
										readyToPrintCharts.map((c) => c.id),
										"charts"
									)
								}
							>
								<Download className="w-6 mr-2" />
								<p className="mt-2">Download All</p>
							</button>
						</div>
						{readyToPrintCharts.filter(chart => chart.printRequested).length > 0 && <div className='flex flex-row ml-10'>
							<button
								className="flex flex-row items-center text-base font-semibold cursor-pointer text-primary-blue"
								onClick={() =>
									printAll(
										readyToPrintCharts.map((c) => c.id),
									)
								}
							>
								<PrinterIcon className="w-6 mr-2" />
								<p className="mt-2">Print All Charts</p>
							</button>
						</div>
						}
						<div className='flex flex-row ml-10'>
							<button
								className='flex flex-row items-center text-base font-semibold cursor-pointer text-primary-blue'
								onClick={() => markChartsAsPrinted(readyToPrintCharts.map((c) => c.id))}
							>
								<BookmarkIcon
									className='w-6 mr-2'
								/>
								<p
									className='mt-2'
								>
									Mark Charts as Printed
								</p>
							</button>
						</div>
					</div>
					{/*TODO: make this scrollable el-377*/}
					<AdminManageClerkCharts charts={readyToPrintCharts} />
				</div>
			)}
			{
				selectedTab === 0 && readyToPrintCharts.length === 0 && (
					<EmptyState>No Charts Found </EmptyState>
				)
			}
			{
				selectedTab === 1 && (
					<ClerkChartsList
						state={otherChartTab}
						updateStatus={updateStatus}
						status={otherChartStatus}
						downloadAll={downloadAll}
						printAll={printAll}
						duplicateChart={duplicateChart}
						downloadChart={downloadChart}
						markChartsAsPrinted={markChartsAsPrinted}
						otherChartQuery={otherChartQuery}
						setOtherChartQuery={setOtherChartQuery}
					/>
				)
			}
			{
				selectedTab === 2 && printedCharts.length > 0 && (
					//TODO: make this scrollable el-377
					<AdminManageClerkCharts charts={printedCharts} />
				)
			}
			{
				selectedTab === 2 && printedCharts.length === 0 && (
					<EmptyState>No Charts Found </EmptyState>
				)
			}
		</div>
	)
}
